module.exports = __webpack_public_path__ + "static/img/zl2.ff61644.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/control2/zl2.png
// module id = qf4V
// module chunks = 7